import { render, staticRenderFns } from "./candidate-list-component.vue?vue&type=template&id=602883f4&scoped=true"
import script from "./candidate-list-component.ts?vue&type=script&lang=ts&external"
export * from "./candidate-list-component.ts?vue&type=script&lang=ts&external"
import style0 from "./candidate-list-component.scss?vue&type=style&index=0&id=602883f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602883f4",
  null
  
)

export default component.exports